import React from 'react';
import { Globe, Target, Users, TrendingUp } from 'lucide-react';
import { commitment } from '../data/mock';

const AboutSection = () => {
  const highlights = [
    {
      icon: Globe,
      title: 'Global Reach',
      description: 'Operating across emerging and frontier markets with on-the-ground expertise'
    },
    {
      icon: Target,
      title: 'Strategic Focus',
      description: 'Delivering transformational insights through decades of real-world experience'
    },
    {
      icon: Users,
      title: 'Client Partnership',
      description: 'Serving both public and private clients with tailored solutions'
    },
    {
      icon: TrendingUp,
      title: 'Sustainable Growth',
      description: 'Acting as a gateway for sustainable global investment into Africa'
    }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-sm tracking-[0.3em] text-gray-500 uppercase mb-3">About Us</p>
          <h2 className="text-3xl md:text-4xl font-serif font-medium text-gray-900 mb-6">
            Your Partner in Global Excellence
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-[#002060] to-gray-400 mx-auto" />
        </div>

        {/* Main Content */}
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <h3 className="text-2xl md:text-3xl font-serif text-gray-900 mb-6 leading-tight">
              Transformational Insights & Strategic Leadership
            </h3>
            <p className="text-gray-600 leading-relaxed mb-6">
              DuPont Management Group (DMG) is a global management consultancy and advisory firm 
              specializing in renewable energy, food security, mining and refining operations, 
              crisis management, and security solutions.
            </p>
            <p className="text-gray-600 leading-relaxed mb-6">
              Our team of experts delivers transformational insights and strategic leadership 
              developed through decades of real-world experience across emerging and frontier markets. 
              DMG acts as a gateway for sustainable global investment into Africa, serving both 
              public and private clients.
            </p>
            <div className="p-6 bg-slate-50 rounded-lg border-l-4 border-[#002060]">
              <p className="text-lg font-serif text-[#002060] italic">
                "{commitment.tagline}"
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6">
            {highlights.map((item, index) => (
              <div
                key={index}
                className="p-6 bg-slate-50 rounded-xl hover:bg-white hover:shadow-xl transition-all duration-300 group border border-transparent hover:border-gray-100"
              >
                <div className="w-12 h-12 bg-[#002060]/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#002060] transition-colors duration-300">
                  <item.icon className="w-6 h-6 text-[#002060] group-hover:text-white transition-colors duration-300" />
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">{item.title}</h4>
                <p className="text-sm text-gray-600 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
